import type { StrokeWidthTokens } from '../types';

export const strokeWidths: StrokeWidthTokens = {
  strokeWidthThin: '1px',
  strokeWidthThick: '2px',
  strokeWidthThicker: '3px',
  strokeWidthThickest: '4px',
};
